import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

// Create Context
const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalBlogs, setTotalBlogs] = useState(0);
const limit=10;
  const fetchBlogs = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/fetchPublishedBlogs?page=${pageNumber}&limit=${limit}`
      );

      if (res.data.success) {
        setBlogs(res.data.blogs || []);
        setTotalPages(res.data.totalPages || 1);
        setTotalBlogs(res.data.totalBlogs || 0);
        setError(null);
      } else {
        setError("Failed to fetch blogs");
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Whenever 'page' changes, fetch corresponding page data
  useEffect(() => {
    fetchBlogs(page);
  }, [page]);
// ***************************************************************************************
const [scheduledBlogs, setScheduledBlogs] = useState([]);
  const [scheduledPage, setScheduledPage] = useState(1);
  const [scheduledLimit] = useState(10);
  const [scheduledTotalPages, setScheduledTotalPages] = useState(1);
  const [scheduledTotal, setScheduledTotal] = useState(0);
  const [scheduledLoading, setScheduledLoading] = useState(false);
  const [scheduledError, setScheduledError] = useState(null);

  const fetchScheduledBlogs = async (pageNumber = 1) => {
    setScheduledLoading(true);
    setScheduledError(null);
    try {
      const response = await axios.get(
        `https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/getScheduledBlogs?page=${pageNumber}&limit=${scheduledLimit}`
      );
      const data = response.data;
      setScheduledBlogs(data.blogs);
      setScheduledPage(data.page);
      setScheduledTotalPages(data.totalPages);
      setScheduledTotal(data.total);
    } catch (error) {
      setScheduledError(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    } finally {
      setScheduledLoading(false);
    }
  };

  useEffect(() => {
    fetchScheduledBlogs(scheduledPage);
  }, [scheduledPage]);


// ***************************************************************************************
const [draftedBlogs, setDraftedBlogs] = useState([]);
  const [draftedPage, setDraftedPage] = useState(1);
  const [draftedLimit] = useState(10);
  const [draftedTotalPages, setDraftedTotalPages] = useState(1);
  const [draftedTotal, setDraftedTotal] = useState(0);
  const [draftedLoading, setDraftedLoading] = useState(false);
  const [draftedError, setDraftedError] = useState(null);

  const fetchDraftedBlogs = async (pageNumber = 1) => {
    setDraftedLoading(true);
    setDraftedError(null);
    try {
      const response = await axios.get(
        `https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/getDraftedBlogs?page=${pageNumber}&limit=${draftedLimit}`
      );
      const data = response.data;
      setDraftedBlogs(data.blogs);
      setDraftedPage(data.page);
      setDraftedTotalPages(data.totalPages);
      setDraftedTotal(data.total);
    } catch (error) {
      setDraftedError(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    } finally {
      setDraftedLoading(false);
    }
  };

  useEffect(() => {
    fetchDraftedBlogs(draftedPage);
  }, [draftedPage]);

// ***************************************************************************
 const [blogStats, setBlogStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsError, setStatsError] = useState(null);

  const fetchStats = async () => {
    setStatsLoading(true);
    setStatsError(null);
    try {
      const response = await axios.get("https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/getBlogStats"); // backend route
      setBlogStats(response.data.data);
    } catch (err) {
      setStatsError(err.response?.data?.message || "Failed to fetch blog stats");
    } finally {
      setStatsError(false);
    }
  };
  useEffect(() => {
    fetchStats();
  }, []);

// ***************************************************************************************

  return (
    <BlogContext.Provider
      value={{
        blogs,
        loading,
        setLoading,
        error,
        page,
        totalPages,
        totalBlogs,
        setPage, // ✅ React state setter
        fetchBlogs,
        limit,
        scheduledBlogs,
        scheduledPage,
        setScheduledPage,
        scheduledLimit,
        scheduledTotalPages,
        scheduledTotal,
        scheduledLoading,
        scheduledError,
        setScheduledLoading,
        draftedBlogs,
        draftedPage,
        setDraftedPage,
        draftedLimit,
        draftedTotalPages,
        draftedTotal,
        draftedLoading,
        draftedError,
        setDraftedLoading,
        blogStats,
        statsLoading,
        statsError,
      }}
    >
      {children}
    </BlogContext.Provider>
  );
};

// Custom hook
export const useBlogs = () => useContext(BlogContext);
